import React, { FC } from 'react'
import { TextInput } from '@moonpig/launchpad-forms'
import { styled } from '@moonpig/launchpad-utils'
import { colorValue } from '@moonpig/launchpad-theme'
import { Box } from '@moonpig/launchpad-components'

const StyledVisuallyHiddenLabel = styled.label`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`

const StyledTextInput = styled(TextInput)<{ noBorder?: boolean }>`
  & label {
    color: ${colorValue('colorTextInverted')};
    font-weight: normal;
  }
  & input {
    ${props => props.noBorder && 'border: none;'}
  }
`

type Props = {
  input: {
    name: string
    value: number | null
    type: 'number' | 'text'
    placeholder: string
    label: string
    errorMessage: string
    maxLength?: number
  }
  inputCtaComponent?: React.ReactNode
  onChange: (value: string) => void
  hasValidValue: boolean
  noBorder?: boolean
}

export const IntegerFilterInput: FC<Props> = ({
  input: { name, value, type, placeholder, label, errorMessage, maxLength },
  inputCtaComponent,
  onChange,
  hasValidValue,
  noBorder,
}) => {
  return (
    <Box width={{ xs: '100%', md: 'auto' }} minWidth={{ md: '300px' }}>
      <StyledVisuallyHiddenLabel htmlFor={name} id="integer-filter-input-label">
        {label}
      </StyledVisuallyHiddenLabel>
      <StyledTextInput
        ariaLabelledBy="integer-filter-input-label"
        name={name}
        id={name}
        type={type}
        maxLength={maxLength}
        hideMaxLengthIndicator
        error={!hasValidValue}
        helperText={hasValidValue ? undefined : errorMessage}
        value={value !== null ? String(value) : ''}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        componentEnd={inputCtaComponent}
        noBorder={noBorder}
      />
    </Box>
  )
}
